export interface BookingCalendarProps {
  branchCode: string
  slot: number
}

export interface BookingSelectBranchProps {
  label: string
  onChange?: (event: { target: { value: string } }) => void
  value?: string | null
  defaultValue?: string | null
  excludeUnconfigured?: boolean
  disabled?: boolean
}

export interface EventType {
  id: string | number
  title: string
  start?: Date
  end?: Date
  status: string | null
  bgColor?: string
  services?: string
}

export const STATUS_COLOR = {
  COMPLETE: '#EAFFEA',
  CONFIRM: '#fccf8b',
  PENDING: 'lightgrey',
  RESERVE: '#adcdff',
}
